import { isNil } from "lodash-es";

import { CurrencyCode, GeneralCurrencyDto } from "@/core/api/generated/v1";

import { useTenantProfile } from "./entity/tenant/useTenantProfile";

const defaultCurrency: GeneralCurrencyDto = {
  code: CurrencyCode.Usd,
  name: CurrencyCode.Usd.toUpperCase(),
};

/** Returns current currency from tenant or user profile, or default currency.
 * @deprecated Use `useCurrentCurrencyV2` instead.
 */
export function useCurrentCurrency({
  useDefault = true,
}: {
  useDefault?: boolean;
} = {}): GeneralCurrencyDto | undefined {
  const tenantProfile = useTenantProfile();

  if (!tenantProfile) {
    return undefined;
  }
  return isNil(tenantProfile) && !useDefault
    ? undefined
    : tenantProfile?.settings?.currency || defaultCurrency;
}
